export default __webpack_public_path__ + "static/media/upArrowHover.b32e9663.png";